<!DOCTYPE HTML>
<template>
<div class="available-providers"
     v-if="project">
  <b-table :items="providers"
           :fields="fields"
           hover
           clickable
           show-empty
           @row-clicked="openProvider">

    <template v-slot:cell(verified)="data">
      <VerificationBadge :status="data.item.verified"
                         small />
    </template>
  </b-table>
</div>
</template>

<script>
// Firebase
const firebase = require( '@/firebaseConfig.js' )
// Components
import VerificationBadge from '@/components/VerificationBadge.vue'
// Mixins
import { Formatter, Skills, Status } from '@/mixins/Mixins.js'
export default {
  name: 'ProviderTable',
  components: {
    VerificationBadge
  },
  mixins: [ Formatter, Skills, Status ],
  props: {
    userData: Object,
    project: Object,
  },
  data() {
    return {
      providers: [],
    }
  },
  firestore: {
    providers: firebase.db.collection( 'users' ).where( 'type', '==', 'provider' ),
  },
  computed: {
    fields() {
      return [ {
          key: 'name',
          label: 'Provider',
          sortable: true,
          sortByFormatted: true,
          formatter: ( value ) => {
            return this.asAnon( value )
          }
        },
        {
          key: 'experience',
          label: 'Years',
          sortable: true
        },
        {
          key: 'verified',
          label: 'Verified',
          sortable: true,
        },
        {
          key: 'rate',
          label: 'Avg rate',
          sortable: true,
          sortByFormatted: true,
          formatter: ( value ) => {
            return this.asHourlyRate( value )
          }
        },
        {
          key: 'skills`',
          label: 'Relevant skills',
          sortable: true,
          sortByFormatted: true,
          formatter: ( value, key, item ) => {
            let n = this.relevantSkills( this.project, item ).length
            return n ? n : null
          }
        },
        {
          key: 'status',
          label: 'Status',
          sortable: true,
          sortByFormatted: true,
          formatter: ( value, key, item ) => {
            return this.shortStatus( this.project, item )
          }
        },
      ]
    },
  },
  methods: {
    openProvider( item ) {
      this.$emit( 'open-provider', item )
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/global.scss";
.available-providers {}
</style>
